import React, { useContext, createContext } from 'react';

const BreadcrumbContext = createContext();

export const useRoutes = () => {
  return useContext(BreadcrumbContext);
};

const BreadcrumbProvider = ({ routes, children }) => {
  return <BreadcrumbContext.Provider value={routes}>{children}</BreadcrumbContext.Provider>;
};

export default BreadcrumbProvider;
